/**
 * YouTube popup modal behavior.
 * Embed URL from #carbuy-youtube-popup[data-embed-url].
 */
(function () {
  'use strict';

  var el = document.getElementById('carbuy-youtube-popup');
  if (!el) {
    return;
  }

  var iframe = el.querySelector('.banner-modal-iframe');
  var embedUrl = String(el.getAttribute('data-embed-url') || '').trim();
  if (!embedUrl) {
    return;
  }

  var cookieName = 'carbuy_youtube_popup_closed';
  var oneDayMs = 24 * 60 * 60 * 1000;
  var html = document.documentElement;

  function getCookie(name) {
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name + '=') === 0) {
        return c.substring(name.length + 1);
      }
    }
    return '';
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
  }

  function show() {
    el.classList.add('banner-modal-visible');
    html.classList.add('modal-open');
    if (iframe) {
      iframe.src = embedUrl;
    }
  }

  function hide() {
    el.classList.remove('banner-modal-visible');
    html.classList.remove('modal-open');
    if (iframe) {
      iframe.src = '';
    }
    setCookie(cookieName, String(Date.now()), 1);
  }

  var closedAt = getCookie(cookieName);
  if (closedAt) {
    var ts = parseInt(closedAt, 10);
    if (!isNaN(ts) && (Date.now() - ts) < oneDayMs) {
      return;
    }
  }

  show();

  var closer = el.querySelector('.banner-modal-closer');
  if (closer) {
    closer.addEventListener('click', function (e) {
      e.preventDefault();
      hide();
    });
  }
  el.addEventListener('click', function (e) {
    if (e.target === el) {
      hide();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && el.classList.contains('banner-modal-visible')) {
      hide();
    }
  });
})();
